// GENERATED BY ./src/scripts/generateComponents.ts
// DO NOT EDIT IT MANUALLY

import React from "react";

import { iconStatasyrupusdc } from "../../../icons/full/build/icon-statasyrupusdc.icon";
import { IconComponentBaseProps } from "../../../utils";
import { Image } from "../../Base/Image";

const StatasyrupusdcIcon = (props: IconComponentBaseProps) => {
  return <Image svgCode={iconStatasyrupusdc.data} {...props} />;
};

if (process.env.NODE_ENV !== 'production') {
  StatasyrupusdcIcon.displayName = 'StatasyrupusdcIcon';
}

export default StatasyrupusdcIcon;